import type { RecordModel } from 'pocketbase';
import { useContext } from 'react';
import { AuthContext } from './authContext';

export type AuthModel = RecordModel | null;

export interface AuthContextType {
  user: AuthModel;
  login: (email: string, password: string) => Promise<void>;
  logout: () => void;
  register: (email: string, password: string, passwordConfirm: string) => Promise<RecordModel>;
  loading: boolean;
  checkAuthAndLogout: () => boolean;
}

export function useAuth() {
  const context = useContext(AuthContext);
  if (context === undefined) {
    throw new Error('useAuth must be used within an AuthProvider');
  }
  return context;
} 